import axios from 'axios';
import { baseUrl, baseUrl1 } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');

export const getAllLobs = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(`${baseUrl}api/QuestionConfiguration/getAllLobs`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const getAllChecklistTemplate = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(`${baseUrl}api/QuestionConfiguration/getAllChecklistTemplate`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};


export const getQuestionsById = async (brokerId: number, templateId: number, lobId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            brokerId: String(brokerId),
            templateId: String(templateId),
            lobId: String(lobId),
        });

        const response = await axios.get(`${baseUrl}api/QuestionConfiguration/getQuestionsById?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const addQuestionConfigData = async (selectedRow: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/addQuestionConfigData", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating QuestionConfig form:", error);
        throw error;
    }
};

export const updateQuestionConfigData = async (selectedRow: any[]) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/updateQuestionConfigData", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error updateQuestionConfigData broker form:", error);
        throw error;
    }
};

export const activateOrDeactivateQConfig = async (body: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/activateOrDeactivateQConfig", body, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error activateOrDeactivateQConfig broker form:", error);
        throw error;
    }
};

export const GetAllQuestionConfigReferanceMapping = async (pageNo: number, pageSize: number, brokerId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = new URLSearchParams({
            pageNo: String(pageNo),
            pageSize: String(pageSize),
            brokerId: String(brokerId)
        });

        const response = await axios.get(`${baseUrl}api/QuestionConfiguration/getAllQuestionConfigReferanceMapping?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const activateOrDeactivateQCBrokerReference = async (id: number, status: boolean) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/QuestionConfiguration/updateQuestionReferanceMappingStatus?id=${id}&status=${status}`,
            {}, // No body data being sent
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error activateOrDeactivateQConfig broker form:", error);
        throw error;
    }
};

export const AddQuestionConfigReferanceMapping = async (brokerId: number, referenceBrokerId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const data = {
            "brokerId": brokerId,
            "refrenceBrokerId": referenceBrokerId
        }
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/addQuestionConfigReferanceMapping", data, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error AddQuestionConfigReferanceMapping form:", error);
        throw error;
    }
};

export const UpdateReferenceBrokerId = async (brokerId: number, referenceBrokerId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/QuestionConfiguration/updateReferenceBrokerId?brokerId=${brokerId}&newReferenceBrokerId=${referenceBrokerId}`,
            {}, // No body data being sent
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error UpdateReferenceBrokerId form:", error);
        throw error;
    }
};

export const RemoveBrokerReferenceMapping = async (recordId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(
            `${baseUrl}api/QuestionConfiguration/removeBrokerReferenceMapping?recordId=${recordId}`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error UpdateReferenceBrokerId form:", error);
        throw error;
    }
};

export const getQuestionMaster = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(`${baseUrl}api/QuestionConfiguration/getQuestionMaster`, {
            headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json"
            },
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching jobs:', error);
        throw error;
    }
};

export const updateQuestionMasterStatus = async (id: number, status: boolean) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/QuestionConfiguration/updateQuestionMasterStatus?Id=${id}&Status=${status}`,
            {}, // No body data being sent
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error activateOrDeactivateQConfig broker form:", error);
        throw error;
    }
};

export const deleteQuestionMasterById = async (recordId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(
            `${baseUrl}api/QuestionConfiguration/deleteQuestionMasterById?Id=${recordId}`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error UpdateReferenceBrokerId form:", error);
        throw error;
    }
};

export const AddorUpdateQuestionMaster = async (body: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/AddorUpdateQuestionMaster", body, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating QuestionConfig form:", error);
        throw error;
    }
};

export const getSplitLobIdentifierConfig = async (
    BrokerIds: number,
    ChecklistLob: string,
    QuestionCode: string,
    JobLobCode: string,
    pageNo: number,
    pageSize: number
) => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem("token") || token
        );

        const params = new URLSearchParams();

        params.append("BrokerIds", BrokerIds.toString())
        params.append("ChecklistLob", ChecklistLob);
        params.append("QuestionCode", QuestionCode);
        params.append("JobLobCode", JobLobCode);
        params.append("PageNo", pageNo.toString());
        params.append("PageSize", pageSize.toString());

        const response = await axios.get(
            `${baseUrl}api/QuestionConfiguration/getSplitLobIdentifierConfig?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateSplitLobIdentifierConfigStatus = async (id: number, status: boolean) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(
            `${baseUrl}api/QuestionConfiguration/updateSplitLobIdentifierConfigStatus?Id=${id}&Status=${status}`,
            {}, // No body data being sent
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error activateOrDeactivateQConfig broker form:", error);
        throw error;
    }
};

export const getChecklistLobCode = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(
            `${baseUrl}api/QuestionConfiguration/getChecklistLobCode`, // No body data being sent
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error activateOrDeactivateQConfig broker form:", error);
        throw error;
    }
};

export const RemoveLobSplitConfigMapping = async (recordId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.delete(
            `${baseUrl}api/QuestionConfiguration/removeLobSplitConfigMapping?recordId=${recordId}`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error UpdateReferenceBrokerId form:", error);
        throw error;
    }
};


export const updateSplitLobIdentifierConfig = async (selectedRow: any[]) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/updateSplitLobIdentifierConfig", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error updateQuestionConfigData broker form:", error);
        throw error;
    }
};

export const addSplitLobIdentifierConfig = async (selectedRow: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/QuestionConfiguration/addSplitLobIdentifierConfig", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error updateQuestionConfigData broker form:", error);
        throw error;
    }
};

export const getChecklistLobDropdown = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem('token') || token
        );

        const response = await axios.get(
            `${baseUrl}api/QuestionConfiguration/getChecklistLobDropdown`,
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (response?.status === 200) {
            return response?.data;
        }

        return [];
    } catch (error) {
        console.error("Error getting Checklist Lob dropdown:", error);
        throw error;
    }
};

export const exportSplitLobIdentifierConfig = async (
    brokerIds: number[],
    checklistLob: string,
    questionCode: string,
    jobLobCode: string
) => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem("token") || token
        );

        const params = new URLSearchParams();

        brokerIds.forEach((id) => {
            params.append("BrokerIds", id.toString());
        });

        params.append("ChecklistLob", checklistLob);
        params.append("QuestionCode", questionCode);
        params.append("JobLobCode", jobLobCode);

        return await axios.get(
            `${baseUrl}api/QuestionConfiguration/exportSplitLobIdentifierConfig`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
                responseType: "blob",
            }
        );
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getAllSplitLobIdentifierConfig = async (
    brokerIds: number[],
    checklistLob: string,
    questionCode: string,
    jobLobCode: string
) => {
    try {
        const Token = await expTokenProcessAndGenerate(
            sessionStorage.getItem("token") || token
        );

        const params = new URLSearchParams();

        brokerIds.forEach((id) => {
            params.append("BrokerIds", id.toString());
        });

        params.append("ChecklistLob", checklistLob);
        params.append("QuestionCode", questionCode);
        params.append("JobLobCode", jobLobCode);

        const response = await axios.get(
            `${baseUrl}api/QuestionConfiguration/getAllSplitLobIdentifierConfig`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        if (response?.status === 200) {
            return response.data;
        }

        return [];
    } catch (error) {
        console.error("Error getting all Lob Split Configuration:", error);
        throw error;
    }
};